import Joi from 'joi';
import mediaUrlSchema from '@utils/validate/blocksSchemes/mediaUrlSchema';
const sloganHomeBlockSchema = Joi.object({
  type: Joi.string().valid('sloganHomeBlock').required(),
  code: Joi.string().allow('', null).optional(),
  text: Joi.string().allow('', null).optional(),
  image: mediaUrlSchema.allow(null).optional()
}).unknown(true);
export default sloganHomeBlockSchema;